import * as TYPES from './types';
import http from '@/utils/api';
import Auth from '@/utils/auth';

const namespaced = true;

const state = () => ({
  number: '',
  numberLength: 0,
  refusals: null,
  model: null,
  questions: null,
  answers: [],
  price: 0,
  selectDiscount: null,
  grade: '',
  discounts: [],
  loading: false,
  calculation: false,
  error: {
    show: false,
    type: '',
  },
  errorSearch: '',
  screenThree: {
    show1: true,
    show2: false,
    show3: false,
  },
  clientInfo: null,
  newOrder: null,
})

const actions = {
  async getOrder ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.get(`/order`, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
        params: data,
      })

      if (response.data.btag)
        commit(TYPES.SET_MODEL, response.data);

      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      console.log(e)
    }
  },

  async getAllRefused ({ commit }, data) {
    try {
      const response = await http.get('/refusal', {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })
      commit(TYPES.SET_REFUSALS, response.data);
    } catch(e) {
      console.log(e);
    }
  },

  async searchModel ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.post('/mobile/create', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })

      if (response.data.ErrorDetails){
        // if(response.data.ErrorDetails === 'Services is not working now!'){
        //   commit(TYPES.SET_ERROR_SEARCH, 'Данное устройство уже прошло оценку, повторите оценку через 3 минуты!');
        // }else{
          commit(TYPES.SET_ERROR_SEARCH, 'Устройство не найдено в системе, проверьте SN. Если все верно, обратитесь в чат технической поддержки.');
        // }

      }else
        commit(TYPES.SET_MODEL, response.data);

      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      commit(TYPES.SET_ERROR_SEARCH, 'Устройство не найдено в системе, проверьте IMEI. Если все верно, обратитесь в чат технической поддержки.');
      console.log(e);
    }
  },

  async changeModel ({ commit }, data) {
    try {
      const response = await http.put('/mobile/redefine', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })
      commit(TYPES.SET_MODEL, response.data);
    } catch(e) {
      console.log(e);
    }
  },

  async getQuestions ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    commit(TYPES.RESET_QUESTINS);
    try {
      const response = await http.get('/mobile/questions', {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      })
      commit(TYPES.SET_QUESTIONS, response.data);
      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      console.log(e);
    }
  },

  async getCalc ({ commit }, data) {
    commit(TYPES.SET_CALCULATION, true);
    try {
      commit(TYPES.SET_LOADING, true);
      const response = await http.post('/mobile/calc', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      })

      commit(TYPES.SET_PRICE, response.data);
      commit(TYPES.SET_GRADE, response.data);
      commit(TYPES.SET_DISCOUNTS, response.data);
      commit(TYPES.SET_CALCULATION, false);
      commit(TYPES.SET_LOADING, false);
      return response.data;
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },

  async agreeModel ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.post('/mobile/agree', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      });

      if (response.data.ErrorDetails)
        commit(TYPES.SET_ERROR, { show: true, type: 'icloud' })
      else
        commit(TYPES.CHANGE_SCREEN_THREE, { show1: false, show2: true });

      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },
  async changeDiscount ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.post('/discount/apply', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      });
      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },
  async updatePrice ({ commit }, price) {
     commit(TYPES.SET_PRICE, {"price": price});
  },
  async clearDiscount ({ commit },discountName) {
    commit(TYPES.SELECT_DISCOUNT,discountName);
    commit(TYPES.CLEAR_DISCOUNT);
  },
  async updateOrder ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.put('/order', data.data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
        params: {
          btag: data.btag,
        }
      });

      commit(TYPES.SET_LOADING, false);

      if (response.data)
        commit(TYPES.SET_ORDER, response.data);
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },

  async cancelModel ({ commit }, data) {
    try {
      const response = await http.post('/mobile/refused', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      });
      return true;
    } catch(e) {
      console.log(e);
    }
  },
}

const mutations = {
  [TYPES.SET_ORDER](state, payload) {
    state.newOrder = payload;
  },

  [TYPES.CHANGE_CLIENT_INFO](state, payload) {
    state.clientInfo = payload;
  },

  [TYPES.CHANGE_SCREEN_THREE](state, payload) {
    for (let key in payload) {
      state.screenThree[key] = payload[key];
    }
  },

  [TYPES.SET_ERROR_SEARCH](state, payload) {
    state.errorSearch = payload;
  },

  [TYPES.SET_ERROR](state, payload) {
    state.error = payload;
  },

  [TYPES.SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [TYPES.SET_CALCULATION](state, payload) {
    state.calculation = payload;
  },
  
  [TYPES.SET_NUMBER](state, payload) {
    state.number = payload.number;
    state.numberLength = payload.length;
  },

  [TYPES.SET_REFUSALS](state, payload) {
    state.refusals = payload;
  },

  [TYPES.SET_PRICE](state, payload) {
    state.price = payload.price;
  },
  [TYPES.SET_GRADE](state, payload) {
    state.grade = payload.grade
  },
  [TYPES.SET_DISCOUNTS](state, payload) {
    if (Array.isArray(payload.discounts)){
      state.discounts = payload.discounts
    }
  },
  [TYPES.CLEAR_DISCOUNT](state) {
    state.discounts = []
  },
  [TYPES.SELECT_DISCOUNT](state, discountName) {
    state.selectDiscount = discountName
  },


  [TYPES.SET_MODEL](state, payload) {
    let model = {};
    if (payload.device) {
      for (let key in payload) {
        if (key == 'device') {
          model['mobile'] = payload[key];
          for (let key2 in payload[key]) {
            if (key2 == 'name') {
              model['mobile']['ModelName'] = payload[key][key2];
            } else
              model['mobile'][key2] = payload[key][key2];
          }
        } else
          model[key] = payload[key];
      }
    } else
      model = payload;
    state.model = model;
  },

  [TYPES.RESET_PHONES](state, payload) {
    state.model = null;
    state.number = '';
    state.numberLength = 0;
    state.screenThree = {
      show1: true,
      show2: false,
      show3: false,
    };
    state.clientInfo = null;
    state.newOrder = null;
  },

  [TYPES.SET_QUESTIONS](state, payload) {
    let questions = payload.groups;
    let answers = [];
    questions.map((item, i) => {
      if (i == 0) {
        item.active = true;
      } else {
        item.active = false
      }
      item.questions.map((item2, i2) => {
        if (i == 0 && i2 == 0) {
          item2.active = true;
        } else {
          item2.active = false;
        }
        answers.push({
          id: item2.id,
          answer: null,
        })
      })
    })
    state.questions = questions;
    state.answers = answers;
  },

  [TYPES.RESET_QUESTINS](state, payload) {
    state.questions = null;
    state.answers = [];
  },

  [TYPES.ADD_ANSWER](state, payload) {
    let itemNum, questionNum, questionId;
    state.questions.map((item, i) => {
      if (item.active == true) {
        item.active = false;
        itemNum = parseInt(i);

        item.questions.map((item2, i2) => {
          if (item2.active == true) {
            item2.active = false;
            questionNum = parseInt(i2);
            questionId = item2.id;
          }
        })
      }
    })

    if (payload.type == 'next') {
      if (state.questions[itemNum].questions[questionNum+1]) {
        state.questions[itemNum].questions[questionNum+1].active = true;
        state.questions[itemNum].active = true;
      } else {
        if (state.questions[itemNum+1]) {
          state.questions[itemNum+1].active = true;
          state.questions[itemNum+1].questions[0].active = true;
        }
      }
      state.answers.map(item => {
        if (item.id == questionId) {
          item.answer = payload.answer;
        }
      })
    } else if (payload.type == 'prev') {
      if (state.questions[itemNum].questions[questionNum-1]) {
        state.questions[itemNum].questions[questionNum-1].active = true;
        state.questions[itemNum].active = true;
      } else {
        state.questions[itemNum-1].active = true;
        state.questions[itemNum-1].questions[state.questions[itemNum-1].questions.length-1].active = true;
      }
    }
  },
}

export default {
  namespaced,
  actions,
  state,
  mutations,
};
